import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/actors',
  component: mainLayout(loadView('actor/Actor')),
  meta: { requiresAuth: true },
  children: [
    {
      path: ':id',
      name: 'ActorDetail',
      component: loadView('actor/ActorDetail'),
      meta: { requiresAuth: true }
    },
    {
      path: ':id/:settingId(\\d+)',
      name: 'ActorDetailBySetting',
      component: loadView('actor/ActorDetailBySetting'),
      meta: { requiresAuth: true }
    },
    {
      path: ':id/:settingId(\\d+)/message',
      component: loadView('actor/message/setting/ActorMessageBySetting'),
      children: [
        {
          path: '',
          name: 'ActorMessageBySetting',
          component: loadView('actor/message/setting/ActorMessageFormBySetting'),
          meta: { requiresAuth: true, isConfirm: false }
        },
        {
          path: 'confirm',
          name: 'ActorMessageConfirmBySetting',
          component: loadView('actor/message/setting/ActorMessageConfirmBySetting'),
          meta: { requiresAuth: true, isConfirm: true }
        },
        {
          path: 'complete',
          name: 'ActorMessageCompleteBySetting',
          component: loadView('actor/message/setting/ActorMessageCompleteBySetting'),
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: ':id/message',
      component: loadView('actor/message/ActorMessage'),
      children: [
        {
          path: '',
          name: 'ActorMessage',
          component: loadView('actor/message/ActorMessageForm'),
          meta: { requiresAuth: true, isConfirm: false }
        },
        {
          path: 'confirm',
          name: 'ActorMessageConfirm',
          component: loadView('actor/message/ActorMessageConfirm'),
          meta: { requiresAuth: true, isConfirm: true }
        },
        {
          path: 'complete',
          name: 'ActorMessageComplete',
          component: loadView('actor/message/ActorMessageComplete'),
          meta: { requiresAuth: true }
        }
      ]
    }
  ]
}
